// Wichtig: Farben für Button in categories/styles.scss ändern (ja, könnte man verbessern...)

module.exports = [
  { ident: 'games', text: 'Spiel und Spass', color: '#c37868' },
  { ident: 'food', text: 'Feinkost und Genuss', color: '#1f9b8c' },
  { ident: 'style', text: 'Style', color: '#dc9d52' },
  { ident: 'culture', text: 'Kunst und Kultur', color: '#4f9099' },
  { ident: 'feelgood', text: 'Wohlfühlen und Bewegung', color: '#8d6aa0' },
  { ident: 'local', text: 'Lokale Manufakturen', color: '#7e562b' },
  { ident: 'interior', text: 'Interior', color: '#4e8ac8' },
  { ident: 'accessoires', text: 'Accessoires', color: '#ee7878' },
  { ident: 'books', text: 'Bücher', color: '#747474' }
]